exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".datepicker-button:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.datepicker-button+.calendar-root .input-date{display:none}.datepicker-button+.calendar-root .calendar{left:0;top:35px;height:auto;min-height:300px}.orders-table tbody td{text-align:center!important}.orders-table tfoot{background-color:rgba(30,136,229,.1)}.text-overpaid{color:#56b962}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-172f714c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Orders/Return.vue
// module id = mHqR
// module chunks = 1